import request from '@/utils/request'

export function fetchList(params) {
  return request({
    url: '/returnParcel/getParcel',
    method: 'get',
    params
  })
}

export function addPackage(data) {
  return request({
    url: '/returnParcel/putParcel',
    method: 'post',
    data
  })
}

export function signPackage(data) {
  return request({
    url: '/returnParcel/cceptParcel',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/package.js